import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import 'vscode/vscode/vs/base/common/arrays';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { joinPath } from 'vscode/vscode/vs/base/common/resources';
import 'vscode/vscode/vs/base/common/path';
import 'vscode/vscode/vs/base/common/platform';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import 'vscode/vscode/vs/base/common/async';
import 'vscode/vscode/vs/base/common/event';
import 'vscode/vscode/vs/base/common/process';
import 'vscode/vscode/vs/base/common/strings';
import 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagement';
import 'vscode/vscode/vs/base/common/network';

let ExtensionTipsService = class ExtensionTipsService extends Disposable {
    constructor(fileService, productService) {
        super();
        this.fileService = fileService;
        this.productService = productService;
        this.allConfigBasedTips = ( new Map());
        if (this.productService.configBasedExtensionTips) {
            Object.entries(this.productService.configBasedExtensionTips).forEach(([, value]) => this.allConfigBasedTips.set(value.configPath, value));
        }
    }
    getConfigBasedTips(folder) {
        return this.getValidConfigBasedTips(folder);
    }
    async getImportantExecutableBasedTips() {
        return [];
    }
    async getOtherExecutableBasedTips() {
        return [];
    }
    async getValidConfigBasedTips(folder) {
        const result = [];
        for (const [configPath, tip] of this.allConfigBasedTips) {
            if (tip.configScheme && tip.configScheme !== folder.scheme) {
                continue;
            }
            try {
                const content = ( (await this.fileService.readFile(joinPath(folder, configPath))).value.toString());
                for (const [key, value] of Object.entries(tip.recommendations)) {
                    if (!value.contentPattern || ( new RegExp(value.contentPattern, 'mig')).test(content)) {
                        result.push({
                            extensionId: key,
                            extensionName: value.name,
                            configName: tip.configName,
                            important: !!value.important,
                            isExtensionPack: !!value.isExtensionPack,
                            whenNotInstalled: value.whenNotInstalled
                        });
                    }
                }
            }
            catch (error) {  }
        }
        return result;
    }
};
ExtensionTipsService = ( __decorate([
    ( __param(0, IFileService)),
    ( __param(1, IProductService))
], ExtensionTipsService));

export { ExtensionTipsService };
